module.exports = __webpack_public_path__ + "static/media/cadou-icon.002020ab.svg";